module.exports = __webpack_public_path__ + "static/media/logo_horizontal_brand.188d02ff.png";